import { render, staticRenderFns } from "./jctp.vue?vue&type=template&id=def350da&scoped=true&"
import script from "./jctp.vue?vue&type=script&lang=js&"
export * from "./jctp.vue?vue&type=script&lang=js&"
import style0 from "./jctp.vue?vue&type=style&index=0&id=def350da&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def350da",
  null
  
)

export default component.exports